import { getTemplatesState } from './templates.selectors'
import ListTrait from 'src/app/traits/list.trait'
import {
  SetDefaultData,
  UpdateField,
  FetchTemplatesRequest,
  DeleteTemplateRequest,
} from './templates.actions'
import { Router, ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnChanges, OnDestroy } from '@angular/core'
import { Subscription } from 'rxjs'
import { Map } from 'immutable'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.css'],
})
export class TemplatesComponent extends ListTrait implements OnInit, OnDestroy {
  private state$: Subscription
  private route$: Subscription
  private shouldReload: boolean = false
  public isLoading: boolean = false
  public columns: object[] = [
    {
      prop: 'name',
      name: 'NAME',
      sortable: true,
    },
    {
      prop: 'type',
      name: 'TYPE',
      sortable: false,
      render: (row) =>
        row &&
        this.translateService.instant(row.get('translationKey'), {
          defaultValue: row.get('title'),
        }),
    },
    {
      width: '162px',
      name: '',
      template: 'actionsColumn',
    },
  ]
  public isTagsVisible = false
  public isTestTemplateVisible = false

  constructor(
    private store: Store<any>,
    public router: Router,
    private route: ActivatedRoute,
    public translateService: TranslateService,
  ) {
    super(router)
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('list'))
    this.state$ = this.store
      .pipe(select(getTemplatesState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')

        if (
          state.get('shouldReload') != this.shouldReload &&
          state.get('shouldReload')
        ) {
          this.runFilter()
        }
        this.shouldReload = state.get('shouldReload')
      })

    this.route$ = this.route.queryParams.subscribe(this.runFilter.bind(this))
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.route$.unsubscribe()
  }

  private runFilter(queryParams: any = {}) {
    const { page, page_size } = this.state.get('queryParams').toJS()
    const params = { page, page_size, ...queryParams }

    this.store.dispatch<any>(
      new FetchTemplatesRequest({
        filters: params.keyword
          ? {
              or: [{ field: 'name', value: params.keyword }],
            }
          : {},
        pageSize: parseInt(params.page_size),
        page: parseInt(params.page) - 1,
        sort: {
          order: params.sort?.toUpperCase(),
          prop: params.order_by,
        },
      }),
    )

    this.store.dispatch(new UpdateField('queryParams', params, 'list'))
  }

  public deleteTemplate(id: number) {
    this.store.dispatch(new DeleteTemplateRequest(id))
  }
}
